module.exports = __webpack_public_path__ + "static/media/upArrow.b933defc.svg";